import { useState, useEffect } from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";

import Img1 from '../../assets/Connecting_the_Bridge_EU_Darkhan_Mongolia_Climate_Action_Pathways_1.jpg';
import Img2 from '../../assets/Breaking_the_Barriers-Interegional_Collaboration_for_Making_Carbon_Market_Works-ROK_and_Central_Asia_1.jpg';
import Img3 from '../../assets/Connecting_the_Bridge_EU_Darkhan_Mongolia_Climate_Action_Pathways_2.jpg';
import Img4 from '../../assets/Forging_Alliance_and_Cooperation_EU_Darkhan_Mongolia_Innovation_Ecosystem_4.jpg';
import Img5 from '../../assets/Setting_up_Innovation_Chain_EU_Darkhan_Mongolia_Innovation_Ecosystems_3.jpg';

import styles from "../../styles/HeroSection.module.css";

const slides = [
  { image: Img1, text: "Connecting the Bridge EU Darkhan Mongolia Climate Action Pathways" },
  { image: Img2, text: "Breaking the Barriers Interegional Collaboration for Making Carbon Market Works ROK and Central Asia" },
  { image: Img3, text: "Connecting the Bridge EU Darkhan Mongolia Climate Action Pathways" },
  { image: Img4, text: "Forging Alliance and Cooperation EU Darkhan Mongolia Innovation Ecosystem" },
  { image: Img5, text: "Setting up Innovation Chain EU Darkhan Mongolia Innovation Ecosystems" },
];

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.hero}>
      <div className={styles.slider}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`${styles.slide} ${index === currentSlide ? styles.active : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className={styles.overlay}>
              <div className={styles.topRow}>
                <div className={styles.content}>
                  <h1 key={currentSlide} className={styles.animateText}>
                    {slide.text}
                  </h1>
                </div>
                <div className={styles.socials}>
                  <div className={styles.icon} onClick={() => window.open('https://www.facebook.com/profile.php?id=61555218584816')}>
                    <FaFacebookF />
                  </div>
                  <div className={styles.icon} onClick={() => window.open('https://www.instagram.com/jsoftbd/')}>
                    <FaInstagram />
                  </div>
                  <div className={styles.icon} onClick={() => window.open('https://www.linkedin.com/company/93344403/admin/dashboard/')}>
                    <FaLinkedinIn />
                  </div>
                  <div className={styles.icon} onClick={() => window.open('https://x.com/home')}>
                    <BsTwitterX />
                  </div>
                </div>
              </div>

              <div className={styles.footer}>
                <div className={styles.dots}>
                  {slides.map((_, idx) => (
                    <span
                      key={idx}
                      className={`${styles.dot} ${idx === currentSlide ? styles.active : ''}`}
                    ></span>
                  ))}
                </div>
              </div>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeroSection;
